import { Component, OnDestroy, OnInit } from '@angular/core';
import { ResultListDto } from '../../../service/dto';

@Component({
  selector: 'app-notification-template-email-list',
  standalone: false,
  templateUrl: './notification-template-email-list.component.html',
  styleUrl: './notification-template-email-list.component.scss'
})
export class NotificationTemplateEmailListComponent{//} implements OnInit, OnDestroy {
	// results?: ResultListDto<PartnerDto>;
	// loading = false;

	// columnRef: TableColumn[] = [
	// 	{ "title": "Logo", "cellRef": "logo" },
	// 	{ "title": "Partner", "property": "name" },
	// 	{ "title": "Contact Person", "cellRef": "contact" }
	// ];

	// constructor(private service: HttpPartnerService, private router: Router, private sanitizer: DomSanitizer) {
	// }

	// ngOnInit(): void {
	// 	this.doFetchResults({
	// 		filters: [],
	// 		pageIndex: 0,
	// 		pageSize: 0
	// 	});
	// }

	// ngOnDestroy(): void {
	// }

	// trackByHashCode(index: number, item: SearchResultDocumentDto): any {
	// 	return item.hashCode;
	// }
	// open(input: PartnerDto){
	// 	this.router.navigate(['partner','view',input.id]);
	// }

	// doFetchResults(input: OnTableChange) {
	// 	this.loading = true;
	// 	this.service.getAll()
	// 		.pipe(finalize(() => {
	// 			this.loading = false;
	// 		}))
	// 		.subscribe(result => {
	// 			this.results = result;
	// 		});
	// }
	// getLogoUrl(row: PartnerDto){
	// 	let out = (row.image as any)['safeUrl'];
	// 	if(out){
	// 		return out;
	// 	}
	// 	out = this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + row.image!.imageData);
	// 	(row.image as any)['safeUrl'] = out;
	// 	return out;
	// }
}
